import React from 'react';

import { FormInstance } from 'antd';
import {
  Select,
  Radio,
} from 'UI';
import {
  PaymentCategoryEnum,
  PaymentCategoryMapping,
  PaymentMethodEnum,
  PaymentMethodMapping,
} from 'constants/payment';

import {
  FormContainer,
  BaseFormItem,
} from './style';

export interface AddClientPaymentFormData {
  paymentCategory: PaymentCategoryEnum
  paymentIsUpfront: string
  paymentMethod: PaymentMethodEnum
}

interface AddClientPaymentFormProps {
  formHandler: FormInstance
  // onSubmit(data: unknown): void
  isLoading?: boolean
}

const AddClientPaymentForm = ({
  formHandler,
  // onSubmit,
  isLoading,
}: AddClientPaymentFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
    // onFinish={onSubmit as (val: unknown) => void}
  >
    <BaseFormItem
      label="Categoria"
      name="paymentCategory"
    >
      <Select disabled={isLoading} placeholder="Selecione">
        {Object.values(PaymentCategoryEnum).map((cat) => (
          <Select.Option value={cat} key={cat}>{PaymentCategoryMapping[cat]}</Select.Option>
        ))}
      </Select>
    </BaseFormItem>
    <BaseFormItem
      label="Precisa pagar adiantamento?"
      name="paymentIsUpfront"
      initialValue="true"
    >
      <Radio.Group>
        <Radio value="true">Sim</Radio>
        <Radio value="false">Não</Radio>
      </Radio.Group>
    </BaseFormItem>
    <BaseFormItem
      label="Forma de pagamento"
      name="paymentMethod"
    >
      <Select disabled={isLoading} placeholder="Selecione">
        {Object.values(PaymentMethodEnum).map((method) => (
          <Select.Option value={method} key={method}>{PaymentMethodMapping[method]}</Select.Option>
        ))}
      </Select>
    </BaseFormItem>
  </FormContainer>
);

AddClientPaymentForm.defaultProps = {
  isLoading: false,
};

export default AddClientPaymentForm;
